import FileDocsManager from "../../components/FileDocsManager";
import { policiesService } from "../../services/apiService";

export default function Policies() {
  return (
    <FileDocsManager
      service={policiesService}
      moduleCode="policies"
      noun="Policy"
      nounPlural="Policies"
    />
  );
}
